import React from 'react'
import styles from './FlexMax.module.scss'

type MaxW = 'xs' | 'sm' | 'md' | 'lg' | 'none'

interface FlexMaxProps {
  children: React.ReactNode
  maxW?: MaxW
  className?: never
}

const maxWMap: Record<MaxW, string> = {
  xs: styles.maxXs, sm: styles.maxSm, md: styles.maxMd, lg: styles.maxLg, none: '',
}

export const FlexMax: React.FC<FlexMaxProps> = ({ children, maxW = 'none' }) => (
  <div className={[styles.base, maxWMap[maxW]].filter(Boolean).join(' ')}>{children}</div>
)
